"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
exports.default = (function (props) {
    var item = props.item, itemContext = props.itemContext, itemHeightRatio = props.itemHeightRatio, onClick = props.onClick, itemRenderer = props.itemRenderer, getResizeProps = props.getResizeProps, getItemProps = props.getItemProps;
    var _a = getResizeProps(), leftResizeProps = _a.left, rightResizeProps = _a.right;
    var itemProps = getItemProps(item.itemProps);
    var onItemClick;
    if (onClick) {
        onItemClick = function () { return onClick(item); };
    }
    // Fix item height from groups with different heights
    var groupHeight = itemContext.dimensions.order.group.height;
    if (groupHeight) {
        itemProps.style.height = groupHeight * itemHeightRatio;
        itemProps.style.lineHeight = groupHeight * itemHeightRatio + "px";
    }
    return (react_1.default.createElement("div", __assign({}, itemProps, { style: {
            height: itemProps.style.height,
            left: itemProps.style.left,
            lineHeight: itemProps.style.lineHeight,
            top: itemProps.style.top,
            width: itemProps.style.width,
        }, onClick: onItemClick }),
        itemContext.useResizeHandle ? react_1.default.createElement("div", __assign({}, leftResizeProps)) : "",
        react_1.default.createElement("div", { className: "rct-item-content", style: __assign(__assign({}, item.style), { maxHeight: "" + itemContext.dimensions.height }) }, itemRenderer ? itemRenderer({ item: item, itemContext: itemContext, getItemProps: getItemProps, getResizeProps: getResizeProps }) : item.title),
        itemContext.useResizeHandle ? react_1.default.createElement("div", __assign({}, rightResizeProps)) : ""));
});
//# sourceMappingURL=index.js.map